
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<aside class=\"third-party-auth\">\n  <div class=\"separator\">{{#t}}or{{/t}}</div>\n  <button id=\"google-login-button\" class=\"button login-button\"><span class=\"google-logo\"></span>{{#t}}Continue with Google{{/t}}</button>\n  <button id=\"apple-login-button\" class=\"button login-button\"><span class=\"apple-logo\"></span>{{#t}}Continue with Apple{{/t}}</button>\n</aside>\n"
      return mustache.render(src, view, partials);
    };
  